import { Tactic } from "../../../redux/tactics/tacticsSlice";
import axios from "../../api";

export const getCodeFromTactic = async ({ tactic }: { tactic: Tactic }) => {
  const res = await axios.post<{ eaCode: string }>(
    `/tactics/get-code-from-tactic/?v=2`,
    {
      teamTactics: tactic.teamTactics,
      playerRoles: tactic.playerRoles.slice(0, 11),
    },
  );
  return res.data;
};
